import { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

import { ProcessTaskAssignEnum, ProcessTaskTypesEnum } from '@thinknet-gmbh/platform-common';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { TaskEditForm } from 'src/pages/tasks-manager/sub-pages/task-list/components/change-task/components/task-edit-form';
import { TaskForm } from 'src/pages/tasks-manager/sub-pages/task-list/components/change-task/components/task-form';
import { IProcessTableTask } from '../edit-process-form.interfaces';

const ChangeProcessTask = ({
  task,
  onClose,
  onUpdateTask,
  onCreateTask,
}: {
  task: IProcessTableTask | null;
  onClose: () => void;
  onCreateTask: (task: IProcessTableTask) => void;
  onUpdateTask: (task: IProcessTableTask) => void;
}) => {

  const { account } = useGetCurrentAccount();

  return (
    <Fragment>
      {!isEmpty(task) ? (
        <TaskEditForm
          onCancel={onClose}
          onSubmit={onUpdateTask}
          initialValue={task}
          accountId={account._id}
        />
      ) : (
        <TaskForm
          initialValue={{
            assignTo: ProcessTaskAssignEnum.PERSONS,
            createdBy: account?._id,
            type: ProcessTaskTypesEnum.PROCESS,
          }}
          onCancel={onClose}
          onSubmit={onCreateTask}
        />
      )}
    </Fragment>
  );
};

export default ChangeProcessTask;
